import { ChangeDetectionStrategy, ChangeDetectorRef, Inject, Component } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CoreLogService } from "../../../core/services/log.service";
import { ISOTService } from '../../services';

export interface CardlimitDialogConfig {
  sot_service: ISOTService;
}

@Component({
  selector: "sot-cardlimitdialog",
  templateUrl: "./cardlimitdialog.component.html",
  styleUrls: ["./cardlimitdialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardlimitDialogComponent {
  private _sotService: ISOTService;

  public constructor(private _changeDetectorRef: ChangeDetectorRef
    , public dialogRef: MatDialogRef<CardlimitDialogComponent, void>
    , @Inject(MAT_DIALOG_DATA) public productTagsConfig: CardlimitDialogConfig
    , private _coreLogService: CoreLogService) {
    this._sotService = productTagsConfig.sot_service;
  }
  ngOnInit() {
    const me = this;
    me.PushChanges();
  }

  public get isModeOne(): boolean {
    return this.productTagsConfig.sot_service.Accessabilty.useModeOne;
  }
  public get isModeTwo(): boolean {
    return this.productTagsConfig.sot_service.Accessabilty.useModeTwo;
  }

  public close() {
    this.dialogRef.close();
  }
  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("CountdownDialogComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }
}
